import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M2_Arrays = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="One-dimensional and Two-dimensional Arrays"
    videos={[
      "https://www.youtube.com/embed/Gn7PGIEJejs", // Array in C language
      "https://www.youtube.com/embed/XAmqWPCG8ew", // One and Two Dimensional Arrays
    ]}
    takeaways={[
      { text: "Understand the definition of an array." },
      {
        text: "Advantages of arrays:",
        points: [
          "No need to maintain separate variables for all elements.",
          "With a single variable name, multiple values can be accessed.",
        ],
      },
      { text: "Learn how array addressing works." },
      {
        text: "Taking input of array elements:",
        points: [
          "Most of the time, we use a for loop to take inputs.",
          "Access elements using array indexing.",
        ],
      },
      { text: "Array indexing starts from 0 to (length - 1)." },
      {
        text: "Two-dimensional array indexing is very important:",
        points: [
          "Learn both row-based indexing and column-based indexing.",
        ],
      },
      { text: "You may be given code and asked to find the output." },
      {
        text: "Standard 2D array questions include:",
        points: ["Matrix addition.", "Matrix multiplication."],
      },
      { text: "For any array-related code, remember the input-taking method." },
    ]}
    questions={[
      "Mostly, questions from this topic will be coding questions where they will provide some simple logic-based problems (for almost all questions, taking input for the array is a part, so remember at least how to take inputs).",
      "The coding questions that come may be a mix of if statements, for loops, and arrays. ",
      "In a two-dimensional array, there may be a possibility of asking standard questions like matrix addition or matrix multiplication (but for any code, the way of taking input is the same, so at least learn that). ",
      "What is the difference between row-wise and column-wise indexing?",
      " In a 2D array, there is a possibility that they will give the starting address and ask for the address of some element in the array where they provide the index of the locations. ",
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M2_Arrays;
